import React from "react";
// CPET
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import cpet1 from "../../../../assets/assesments/physical/cpet/cpet-1.svg";
import cpet2 from "../../../../assets/assesments/physical/cpet/cpet-2.svg";
import cpet3 from "../../../../assets/assesments/physical/cpet/cpet-3.svg";
import cpet4 from "../../../../assets/assesments/physical/cpet/cpet-4.svg";
import Bgshape1 from "../../../../assets/assesments/png/Bg-shape-1.png";
import Bgshape6 from "../../../../assets/assesments/png/Bg-shape-6.png";
import Bgshape7 from "../../../../assets/assesments/png/Bg-shape-7.png";
import Bgshape8 from "../../../../assets/assesments/png/Bg-shape-8.png";
//  UltraSound Police
import ultraPolice1 from "../../../../assets/assesments/physical/ultraPolice/ultraP-1.svg";
import ultraPolice2 from "../../../../assets/assesments/physical/ultraPolice/ultraP-2.svg";
import ultraPolice3 from "../../../../assets/assesments/physical/ultraPolice/ultraP-3.svg";
import ultraPolice4 from "../../../../assets/assesments/physical/ultraPolice/ultraP-4.svg";
import Thyroid from "../../../../assets/assesments/physical/ultraPolice/Thyroid.svg";
import Liver from "../../../../assets/assesments/physical/ultraPolice/Liver.svg";
import Spleen from "../../../../assets/assesments/physical/ultraPolice/Spleen.svg";
import Gallbladder from "../../../../assets/assesments/physical/ultraPolice/Gallbladder.svg";
import Kidneys from "../../../../assets/assesments/physical/ultraPolice/Kidneys.svg";
import Pancreatic from "../../../../assets/assesments/physical/ultraPolice/Pancreatic_Head.svg";
import Abdominal from "../../../../assets/assesments/physical/ultraPolice/Abdominal_aorta.svg";
import bladder from "../../../../assets/assesments/physical/ultraPolice/Urinary_bladder.svg";
import Scrotum from "../../../../assets/assesments/physical/ultraPolice/Scrotum.svg";
import Epididymal from "../../../../assets/assesments/physical/ultraPolice/Epididymal_Head.svg";
import Uterus from "../../../../assets/assesments/physical/ultraPolice/Uterus.svg";
import Endometrium from "../../../../assets/assesments/physical/ultraPolice/Endometrium.svg";
import RightOvary from "../../../../assets/assesments/physical/ultraPolice/RightOvary.svg";
import LeftOvary from "../../../../assets/assesments/physical/ultraPolice/LeftOvary.svg";
import Prostate from "../../../../assets/assesments/physical/ultraPolice/Prostate.svg";
import Ovary from "../../../../assets/assesments/physical/ultraPolice/Ovary.svg";
import Comparisons from "../../../../assets/assesments/physical/ultraPolice/History_Comparisons.svg";
// Vital
import vitals6 from "../../../../assets/assesments/physical/vitals/Vitals6.svg";
import vitals7 from "../../../../assets/assesments/physical/vitals/Vitals7.svg";
import vitals8 from "../../../../assets/assesments/physical/vitals/Vitals8.svg";
import vitals9 from "../../../../assets/assesments/physical/vitals/Vitals9.svg";
//
import physical1 from "../../../../assets/assesments/physical/physical/physical-1.svg";
import physical2 from "../../../../assets/assesments/physical/physical/physical-2.svg";
import physical3 from "../../../../assets/assesments/physical/physical/physical-3.svg";
import physical4 from "../../../../assets/assesments/physical/physical/physical-4.svg";
import Heent from "../../../../assets/assesments/physical/physical/heent.svg";
import Neck from "../../../../assets/assesments/physical/physical/neck.svg";
import Cardiac from "../../../../assets/assesments/physical/physical/cardiac.svg";
import Lungs from "../../../../assets/assesments/physical/physical/lungs.svg";
import Abdomen from "../../../../assets/assesments/physical/physical/abdomen.svg";
import Back from "../../../../assets/assesments/physical/physical/back.svg";
import Extremities from "../../../../assets/assesments/physical/physical/extremities.svg";
import Genitourinary from "../../../../assets/assesments/physical/physical/genitourinary.svg";
import Neurological from "../../../../assets/assesments/physical/physical/neurological.svg";
import Skin from "../../../../assets/assesments/physical/physical/skin.svg";

export const swiperData = [
  {
    image: cpet1,
  },
  {
    image: cpet2,
  },
  {
    image: cpet3,
  },
  {
    image: cpet4,
  },
];

// Ultrasound Police

export const cardDesign = [
  {
    color: `linear-gradient(177.63deg, #FCF0FF 50%, rgba(232, 244, 252, 0) 100%)`,
    image: Bgshape1,
  },
  {
    color: `linear-gradient(180deg, #F0F9F2 50%, rgba(242, 231, 245, 0) 100%)`,
    image: Bgshape8,
  },
  {
    color: `linear-gradient(180.31deg, #FFF2EB 50%, rgba(251, 238, 255, 0) 100%)`,
    image: Bgshape6,
  },
  {
    color: `linear-gradient(180deg, #E6F1FA 50%, rgba(255, 247, 244, 0) 100%)`,
    image: Bgshape7,
  },
];

export const ultraSoundPoliceswiperData = [
  {
    image: ultraPolice1,
  },
  {
    image: ultraPolice2,
  },
  {
    image: ultraPolice3,
  },
  {
    image: ultraPolice4,
  },
];

export const UltrasoundOrgan = [
  {
    key: "thyroid",
    svgIcon: Thyroid,
  },
  {
    key: "liver",
    svgIcon: Liver,
  },
  {
    key: "gallbladder",
    svgIcon: Gallbladder,
  },
  {
    key: "kidney",
    svgIcon: Kidneys,
  },
  {
    key: "pancreas",
    svgIcon: Pancreatic,
  },
  {
    key: "spleen",
    svgIcon: Spleen,
  },
  {
    key: "aorta",
    svgIcon: Abdominal,
  },
  {
    key: "bladder",
    svgIcon: bladder,
  },
  {
    key: "scrotum",
    svgIcon: Scrotum,
  },
  {
    key: "epididymal_head",
    svgIcon: Epididymal,
  },
  {
    key: "uterus",
    svgIcon: Uterus,
  },
  {
    key: "endometrium",
    svgIcon: Endometrium,
  },
  {
    key: "right_ovarian",
    svgIcon: RightOvary,
  },
  {
    key: "left_ovarian",
    svgIcon: LeftOvary,
  },
  {
    key: "prostate",
    svgIcon: Prostate,
  },
  {
    key: "ovarian",
    svgIcon: Ovary,
  },
  {
    key: "history_comparisons",
    svgIcon: Comparisons,
  },
];

// Vital Data

export const vitalSwiperData = [
  {
    image: vitals6,
  },
  {
    image: vitals7,
  },
  {
    image: vitals8,
  },
  {
    image: vitals9,
  },
];

// CPET ASSESSMENT

export const legends1 = [
  {
    color: "#c40a0a",
    label: "HR",
  },
  {
    color: "#d86eeb",
    label: "Carbs",
  },
  {
    color: "#acc452",
    label: "Fat",
  },
  {
    color: "#000",
    label: "Work",
  },
];

export const legends2 = [
  {
    color: "#FBFBFB",
    label: "Zone 1",
  },
  {
    color: "#EFF5FE",
    label: "Zone 2",
  },
  {
    color: "#F2FBF5",
    label: "Zone 3",
  },
  {
    color: "#FFF8EB",
    label: "Zone 4",
  },
  {
    color: "#FFE1E2",
    label: "Zone 5",
  },
];

export const chartData = [
  {
    label: "AEROBIC",
    color: "#6B7EE9",
    detail: "Fat Oxidation",
    detailBgColor: "#E2ECFD",
    detailTextColor: "#6B7EE9",
  },
  {
    label: "VT1",
    color: "#34A259",
    detail: (
      <>
        Transition
        <span style={{ display: "flex", alignItems: "center" }}>
          Fat <ArrowForwardIcon fontSize="small" /> Carbs
        </span>
      </>
    ),
    detailBgColor: "#E0F8E7",
    detailTextColor: "#34A259",
  },
  {
    label: "RER=1",
    color: "#F07610",
    detail: (
      <>
        Anaerobic
        <span style={{ display: "flex", alignItems: "center" }}>
          <ArrowUpwardIcon fontSize="small" /> Carbs
        </span>
        <span style={{ display: "flex", alignItems: "center" }}>
          <ArrowUpwardIcon fontSize="small" /> Lactate
        </span>
      </>
    ),
    detailBgColor: "#FDE9C8",
    detailTextColor: "#F07610",
  },
  {
    label: "VT2",
    color: "#9D1719",
    detail: (
      <>
        <span style={{ display: "flex", alignItems: "center" }}>
          <ArrowUpwardIcon fontSize="small" />{" "}
          <ArrowUpwardIcon fontSize="small" /> Lactate
        </span>
        <span>Fatigue</span>
      </>
    ),
    detailBgColor: "#FFE1E2",
    detailTextColor: "#9D1719",
  },
  {
    label: "MAX",
    color: "#202024",
    detail: "",
    detailBgColor: "#fff",
    detailTextColor: "#000",
  },
];

// CPET year on year

export const yearOnYearoptionLegends1 = [
  {
    color: "#34A259",
    label: "O2 - Pulse",
  },
  {
    color: "#3A3A40",
    label: "HR",
  },
  {
    color: "#F07610",
    label: "VO2 ml/kg",
  },
  {
    color: "#6B7EE9",
    label: "Watts",
  },
];
export const yearOnYearoptionLegends2 = [
  {
    label: "•••• Previous Year",
  },
  {
    label: "── Current Year",
  },
];

// peplan data

export const arrayOfMockData = [
  {
    staticIcon: Heent,
    staticTitle: "HEENT (Head, Eyes, Ears, Nose and Neck)",
  },
  {
    staticIcon: Neck,
    staticTitle: "Neck",
  },
  {
    staticIcon: Skin,
    staticTitle: "Skin",
  },
  {
    staticIcon: Neurological,
    staticTitle: "Neurological",
  },
  {
    staticIcon: Back,
    staticTitle: "Back",
  },
  {
    staticIcon: Cardiac,
    staticTitle: "Cardiac",
  },
  {
    staticIcon: Abdomen,
    staticTitle: "Abdomen",
  },
  {
    staticIcon: Lungs,
    staticTitle: "Lungs",
  },
  {
    staticIcon: Genitourinary,
    staticTitle: "Genitourinary (GU)",
  },
  {
    staticIcon: Extremities,
    staticTitle: "Extremities",
  },
];

export const peplanSwiperData = [
  {
    image: physical1,
  },
  {
    image: physical2,
  },
  {
    image: physical3,
  },
  {
    image: physical4,
  },
];

export const keyInsights = [
  { color: "#1780C6", backGround: "#E3F1F9" },
  { color: "#2D8F4E", backGround: "#F0F9F2" },
  { color: "#8B3F9E", backGround: "#F2E7F5" },
  { color: "#FFB142", backGround: "#FFF7EC" },
];
